import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
  useEffect,
} from "react";

export const SetProjectsAgentHiddenContext = createContext<
  Dispatch<SetStateAction<boolean>>
>(() => {});

/** Hides the agent chat beside the projects area while `hidden` holds, for a view with nothing to ask the agent about. */
export function useHideProjectsAgent(hidden: boolean) {
  const setHidden = useContext(SetProjectsAgentHiddenContext);
  useEffect(() => {
    if (!hidden) return;
    setHidden(true);
    return () => setHidden(false);
  }, [hidden, setHidden]);
}
